import axios from "axios";
import { sendPasswordResetEmail } from "firebase/auth";
import {
  addDoc,
  arrayUnion,
  collection,
  doc,
  documentId,
  getDoc,
  getDocs,
  onSnapshot,
  query,
  updateDoc,
  where,
} from "firebase/firestore";
import { httpsCallable, getFunctions } from "firebase/functions";
import React, { useEffect, useRef, useState } from "react";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { useHistory, useParams } from "react-router-dom";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { Box, Table, Tooltip } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Form,
  FormGroup,
  FormInput,
  FormSelect,
  ListGroup,
  ListGroupItem,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "shards-react";
import swal from "sweetalert";
import { app, auth, db, firebaseFunctions } from "../../../firebase";
import { useAuth } from "../../../providers/AuthProvider";
import FeatureFlagModal from "../FeatureFlag/FeatureFlag";
import Calibration from "./Calibration";
import dayjs from "dayjs";
import MonitoringUsers from "./MonitoringUsers";
import { checkDateisAfterToday, uuidv4 } from "../../../utils/common_handlers";
import TrainingResult from "./TrainingResult";
import "./tab.css";
import Answers from "./Answers";
import TestsCalendar from "./Calendar/TestsCalendar";
import { TextField } from "@mui/material";
import FullFeaturedCrudGrid from "./FullFeatureGrid";
import VergenceTestsGrid from "./VergenceTestsGrid";
import ProprietaryTestsGrid from "./ProprietaryTestsGrid";
import TrainingProSettings from "./TrainingProSettings";

import {
  getAdditionalUserInfo,
  updateUserFlag,
  updateHasDoubleVision,
} from "../../../utils/api_calls";
import { Cloud_API_URL } from "../../../utils/constants";

var moment = require("moment"); // require
const theme = createTheme({
  components: {
    MuiCssBaseline: {
      styleOverrides: `
        #mui-popper {
          left: calc(100% - 300px) !important;
        }
      `,
    },
  },
});
const Userdetails = () => {
  const { id } = useParams();
  const history = useHistory();
  const chatMessagesEndRef = useRef();
  const [user, setUser] = useState("");
  const [hasSubscription, setHasSubscription] = useState(false);
  const [guardian, setGuardian] = useState("");
  const [approvedBy, setApprovedBy] = useState({});
  const [userAuthData, setUserAuthData] = useState("");
  const [toggleState, setToggleState] = useState(1);
  const [otherDetailsEdit, setOtherDetailsEdit] = useState(false);
  const [userDetailsEdit, setUserDetailsEdit] = useState(false);
  const [MovementSpeed, setMovementSpeed] = useState("");
  const [DefaultCalibrationMoment, setDefaultCalibrationMoment] = useState("");
  const [PersonalOffset, setPersonalOffset] = useState("");
  const [physicalDistance, setPhysicalDistance] = useState(0);
  const [ReadCalibrationFromBackend, setReadCalibrationFromBackend] =
    useState(false);
  const [offsetValue, setOffsetValue] = useState(null);
  const [pendlumLength, setPendlumLength] = useState(null);
  const [RecommendedSessionsPerWeek, setRecommendedSessionsPerWeek] =
    useState("");
  const [vrOffset, setVROffset] = useState("");
  const [changeFlag, setChangeFlag] = useState(false);
  const [hasDoubleVisionFlag, setHasDoubleVisionFlag] = useState(false);
  const [tempFlag, setTempFlag] = useState(changeFlag);
  const [sqlUserData, setSqlUserData] = useState([]);
  const [activeInactive, setActiveInactive] = useState("");
  const [MobileNumber, setMobileNumber] = useState("");
  const [Age, setAge] = useState("");
  const [ValidTill, setValidTill] = useState(new Date());
  const [answerData, setAnswerData] = useState([]);
  const [readingSpeedData, setReadingSpeedData] = useState([]);
  const [readingTestsScores, setReadingTestsScores] = useState([]);
  const [deletingUser, setDeletingUser] = useState(false);
  const [calibrationOn, setCalibrationOn] = useState(false);
  const [proTraining, setShowProTraining] = useState(false);
  const [approvalStatusLoading, setApprovalStatusLoading] = useState(false);
  const [approved, setApproved] = useState(false);
  const [vergenceData, setVergenceData] = useState([]);
  const [combinedData, setCombinedData] = useState([]);
  const [surveyAnswers, setSurveyAnswers] = useState([]);
  const [trainingQuestions, setTrainingQuestions] = useState([]);

  //Auth userRole
  const { userRole, currentUser } = useAuth();

  //comment
  const [commentText, setCommentText] = useState("");
  const [comments, setComments] = useState([]);

  // in-app messages
  const inAppMessagesEndRef = useRef();
  const [inAppAction, setInAppAction] = useState(false);
  // const [userNotificationDoc, setUserNotificationDoc] = useState(null);
  const [inAppMsgWithFeedback, setInAppMsgWithFeedback] = useState(false);
  const [inAppMessage, setInAppMessage] = useState("");
  const [inAppMessages, setInAppMessages] = useState([]);
  const [selectedDuration, setSelectedDuration] = useState(7);

  const [resetEmail, setResetEmail] = useState("");
  const [featureFlagModal, setFeatureFlagModal] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [resetLoading, setEmailResetLoading] = useState(false);
  const [resetResponse, setResetResponse] = useState("");
  const [showProTrainingSettings, setShowProTrainingSettings] = useState(false);

  let intialDeviceState = {
    manufacturer: "",
    model: "",
    os: "",
    osversion: "",
    version: "",
  };
  const [deviceData, setDeviceData] = useState(intialDeviceState);
  const cloudFunctions = getFunctions(app, "europe-west3");
  const BASE_URL = process.env;
  const answers = ["Never", "Rarely", "Sometimes", "Quite often", "Always"];
  const groupedAnswers = groupSurveyAnswers(surveyAnswers);
  useEffect(() => {
    const fetchSubscriptionStatus = async () => {
      const url = `${Cloud_API_URL}/user/check-subscription?uuid=${id}`;
      try {
        const response = await fetch(url);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        setHasSubscription(data.hasSubscription);
      } catch (error) {
        console.error("Failed to fetch subscription status: ", error);
      }
    };

    fetchSubscriptionStatus();
  }, [id]);

  useEffect(() => {
    const mergedData = [
      ...vergenceData,
      ...transformFirebaseDataToTableData(answerData),
    ];

    // Sort the mergedData by the answeredOn field
    const sortedData = mergedData.sort((a, b) => {
      const dateA = moment(a.answeredOn, "MMMM D, YYYY");
      const dateB = moment(b.answeredOn, "MMMM D, YYYY");

      return dateA.isBefore(dateB) ? 1 : dateA.isAfter(dateB) ? -1 : 0;
    });
    // Reorder the id fields
    const reorderedData = sortedData.map((item, index) => {
      return {
        ...item,
        id: index + 1,
      };
    });

    setCombinedData(reorderedData);
  }, [vergenceData, answerData]);

  function transformApiDataToTableData(apiData) {
    return apiData.sessions.map((session, index) => {
      const totalValue = session.questions.reduce((acc, q) => acc + q.value, 0);
      const formattedDate = moment(session.created_at).format("MMMM D, YYYY");

      return {
        id: index + 1,
        total: totalValue,
        answeredOn: formattedDate,
        details: session.questions,
        session: session.session,
      };
    });
  }
  function transformFirebaseDataToTableData(firebaseData) {
    return firebaseData.map((item, index) => {
      return {
        id: index + 1 + vergenceData.length,
        total: item.Total,
        answeredOn: moment(item.DateOfAnswering.toDate()).format(
          "MMMM D, YYYY"
        ),
        details: item.Answers.map((q) => ({
          question: q.Question,
          answer: answers[q.Answer],
        })),
      };
    });
  }
  const getSqlUserData = async (uuid) => {
    const data = await getAdditionalUserInfo(uuid);
    if (data && data.has_double_vision !== null) {
      setHasDoubleVisionFlag(data.has_double_vision);
    }
    setSqlUserData(data);
  };

  const toggleTab = (index) => {
    setToggleState(index);
  };
  // Helper function to group answers by question
  function groupSurveyAnswers(surveyAnswers) {
    const grouped = {};

    surveyAnswers.forEach(({ question, answer }) => {
      if (!grouped[question]) {
        grouped[question] = [];
      }
      grouped[question].push(answer);
    });

    // Convert object to array, joining answers by commas (or any delimiter)
    return Object.entries(grouped).map(([question, answers]) => ({
      question,
      answers: answers.join(", "),
    }));
  }

  const getSurveyAnswers = async () => {
    try {
      const response = await axios.get(
        `${Cloud_API_URL}/user/get-survey-answers?uuid=${id}`
      );
      if (response.data.success) {
        setSurveyAnswers(response.data.data);
      } else {
        console.error(
          "Failed to retrieve survey answers:",
          response.data.message
        );
      }
    } catch (error) {
      console.error("Error fetching survey answers:", error);
    }
  };
  const getTrainingQuestions = async () => {
    try {
      const response = await axios.get(
        `${Cloud_API_URL}/user/get-training-questions?uuid=${id}`
      );
      if (response.data.success) {
        setTrainingQuestions(response.data.data);
      } else {
        if (
          response.data.message ===
          "No training question data found for this user."
        ) {
          // If no training questions are found, set an empty array
          console.log(response.data.message);
          setTrainingQuestions([]);
        } else {
          console.error(
            "Failed to retrieve training questions: ",
            response.data.message
          );
        }
      }
    } catch (error) {
      console.error("Error fetching training questions:", error);
    }
  };

  useEffect(() => {
    getUserData();
    getSqlUserData(id);
    getUserState();
    getSurveyAnswers();
    getTrainingQuestions();
  }, []);

  useEffect(() => {
    if (id) {
      const url = `${Cloud_API_URL}/vergence-tests/results?uuid=${id}`;

      fetch(url)
        .then((response) => {
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          return response.json();
        })
        .then((data) => {
          if (data) {
            const tableData = transformApiDataToTableData(data);
            setVergenceData(tableData);
          } else {
            setVergenceData([]);
          }
        })
        .catch((error) => {
          console.error(
            "There was a problem with the fetch operation:",
            error.message
          );
        });
    }
  }, [id]);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  let commentListenerVar;
  let notificationListenerVar;

  const getUserData = async () => {
    const docRef = doc(db, "UserData", id);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      if (docSnap.data().Guardian) {
        getGuardianData(docSnap.data().Guardian.id);
      }
      axios
        .get(
          `${process.env.REACT_APP_API_GATEWAY_CLOUDRUN}user/parent-info?uuid=${id}`
        )
        .then((response) => {
          if (response.data) {
            setApprovedBy(response.data);
          } else {
            console.log("No guardian information found via API.");
          }
        })
        .catch((error) => {
          console.error("Error fetching guardian information from API:", error);
        });
      const userInfo = { ...docSnap.data(), uuid: id };
      setUser(userInfo);
      setMovementSpeed(docSnap.data().MovementSpeed);
      setDefaultCalibrationMoment(
        docSnap.data().DefaultCalibrationMoment &&
          docSnap.data().DefaultCalibrationMoment
      );
      setPersonalOffset(docSnap.data().PersonalOffset);
      setPhysicalDistance(docSnap.data().PhysicalDistance);
      setReadCalibrationFromBackend(docSnap.data().ReadCalibrationFromBackend);
      setRecommendedSessionsPerWeek(docSnap.data().RecommendedSessionsPerWeek);
      setMobileNumber(docSnap.data().MobileNumber);
      setOffsetValue(
        docSnap.data().CalibrationBackend &&
          docSnap.data().CalibrationBackend.offsetValue
      );
      setPendlumLength(
        docSnap.data().CalibrationBackend &&
          docSnap.data().CalibrationBackend.pendlumLength
      );
      setAge(docSnap.data().Age);
      setVROffset(docSnap.data().VROffset ? docSnap.data().VROffset : "");
      setDeviceData(
        docSnap.data().DeviceInfo
          ? docSnap.data().DeviceInfo
          : intialDeviceState
      );
      setChangeFlag(
        docSnap.data().ChangeFlag ? docSnap.data().ChangeFlag : false
      );
      setTempFlag(
        docSnap.data().ChangeFlag ? docSnap.data().ChangeFlag : false
      );
      setCalibrationOn(!docSnap.data().FeatureFlag.calibration.x || false);
      setShowProTraining(docSnap.data().FeatureFlag.ProTraining || false);

      docSnap.data().ValidTill &&
        setValidTill(moment(docSnap.data().ValidTill.toDate().toDateString()));
      docSnap.data().TrainingApprovedStatus &&
        getApprovalStatus(docSnap.data().TrainingApprovedStatus);
      docSnap.data().UserAnswers &&
        getUserAnswerData(docSnap.data().UserAnswers);
      docSnap.data().ReadingSpeed &&
        getUserReadingSpeedData(docSnap.data().ReadingSpeed);
      docSnap.data().Comments && commentListener(docSnap.data().Comments);
      docSnap.data().UserNotifications &&
        notificationListener(docSnap.data().UserNotifications);

      // Initialize the function 'getUserReadingTestsResults' in Google Cloud Functions
      const getUserResults = httpsCallable(
        cloudFunctions,
        "getUserReadingTestsResults"
      );
      console.log("Calling cloud function for user results");
      getUserResults({ email: docSnap.data().Email })
        .then((response) => {
          if (response.data) {
            setReadingTestsScores(response.data);
            console.log("User reading test scores updated");
          } else {
            console.log("No reading test scores returned for this email");
          }
        })
        .catch((error) => {
          console.log("Error fetching user results", error);
        });
    } else {
      console.log("No such document!");
    }
  };

  const getApprovalStatus = async (path) => {
    try {
      setApprovalStatusLoading(true);
      const docRef = doc(db, "ApprovalEmails", path.id);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        if (docSnap.data().Approved) {
          setApproved(true);
        } else {
          setApproved(false);
        }
        setApprovalStatusLoading(false);
      } else {
        setApprovalStatusLoading(false);
        setApproved(false);
      }
    } catch (error) {
      setApprovalStatusLoading(false);
      console.log(error);
    }
  };

  const sendApprovalRequest = async (email) => {
    try {
      const functionCall = httpsCallable(
        firebaseFunctions,
        "approveTrainingAdmin"
      );
      const response = await functionCall({
        userEmail: email,
      });
      if (response.data.success) {
        const userRef = doc(db, "UserData", id);
        await updateDoc(userRef, {
          TrainingApprovedStatus: doc(
            db,
            "ApprovalEmails",
            response.data.success.split("/")[1]
          ),
        });
        getApprovalStatus(
          doc(db, "ApprovalEmails", response.data.success.split("/")[1])
        );
        alert("Approved");
      } else {
        alert("something went wrong");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const deleteUser = async (uid) => {
    swal({
      title: "Are you sure?",
      text: "You want to delete this user!",
      icon: "error",
      buttons: true,
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        try {
          if (uid !== "") {
            setDeletingUser(true);
            swal({
              title: "Deleting",
              text: "Deleting user data",
              icon: "info",
            });
            const functionCall = httpsCallable(
              firebaseFunctions,
              "userDeletion-deleteUser"
            );
            const response = await functionCall({
              uid: uid,
            });
            swal.close();
            if (response.data.success) {
              swal({
                title: "Success!",
                text: "User deleted",
                icon: "success",
              });
              history.goBack();
            } else {
              swal({
                title: "Error!",
                text: response.data.errorInfo
                  ? response.data.errorInfo.message
                  : "Some error occured",
                icon: "error",
              });
            }
            setDeletingUser(false);
          } else {
            swal({
              title: "Warning!",
              text: "Please provide id",
              icon: "warning",
            });
          }
        } catch (error) {
          swal({
            title: "Error!",
            text: error.message,
            icon: "error",
          });
          setDeletingUser(false);
        }
      }
    });
  };

  const resetPasswordModal = (email) => {
    setResetResponse("");
    setEmailResetLoading(false);
    setResetEmail(email);
    setModalVisible(!modalVisible);
  };

  const sendResetPasswordEmailForChildAccount = async (childAccountEmail) => {
    try {
      let resetPasswordEmailURL = `${Cloud_API_URL}/user/reset-child-account-password`;

      const result = axios.post(resetPasswordEmailURL, {
        childAccountEmail,
      });

      const response = await result.json();

      return response;
    } catch (error) {
      console.log("Error sending reset password email: ", error);
      return [];
    }
  };

  const sendResetPasswordEmailToMichael = async (email) => {
    try {
      let resetPasswordEmailURL = `${Cloud_API_URL}/user/send-reset-password-to-admin`;

      const result = axios.post(resetPasswordEmailURL, {
        childAccountEmail: email,
      });

      const response = await result.json();

      return response;
    } catch (error) {
      console.log("Error sending reset password email: ", error);
      return [];
    }
  };

  const sendResetPasswordLink = async (resetEmail) => {
    try {
      if (resetEmail) {
        // if account is a child account send the reset password to the guardian
        if (resetEmail.includes("@imvilabs-child.com")) {
          setEmailResetLoading(true);
          await sendResetPasswordEmailForChildAccount(resetEmail);
          setResetResponse("Sent successfully");
        } else if (resetEmail.includes("@elev.iadhoc.se")) {
          setEmailResetLoading(true);
          await sendResetPasswordEmailToMichael(resetEmail);
          setResetResponse("Sent successfully");
        } else {
          setEmailResetLoading(true);
          await sendPasswordResetEmail(auth, resetEmail);
          setResetResponse("Sent successfully");
        }
      }
    } catch (error) {
      setResetResponse("Something went wrong. Try again");
      setEmailResetLoading(false);
    }
  };

  const getUserState = async () => {
    axios
      .get(BASE_URL.REACT_APP_API_URL + `/admin/getUser/${id}`)
      .then((res) => {
        setUserAuthData(res.data.data);
        setActiveInactive(res.data.data.disabled);
      });
  };

  const getGuardianData = async (GuardianId) => {
    const docRef = doc(db, "Guardian", GuardianId);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      setGuardian(docSnap.data());
    } else {
      console.log("No such document in Firestore. Trying API...");
    }
  };

  const UpdateStatus = () => {
    let data = {
      user_uid: id,
      disabled: activeInactive ? false : true,
    };
    axios
      .put(BASE_URL.REACT_APP_API_URL + `/admin/disableUser`, data)
      .then((res) => {
        getUserState();
      });
  };

  const UpdateUserDetails = async () => {
    try {
      // 1) Update SQL
      await axios.put(`${Cloud_API_URL}/user/update-user-profile-by-uuid`, {
        uuid: id,
        phoneNumber: MobileNumber,
        age: Age !== "" && Age !== null ? Number(Age) : undefined,
        validUntil: new Date(ValidTill).toISOString(),
      });

      // 2) Update Firebase
      const washingtonRef = doc(db, "UserData", id);
      await updateDoc(washingtonRef, {
        Age: Age,
        ValidTill: new Date(ValidTill),
      });

      setUserDetailsEdit(false);
      getUserData();
    } catch (err) {
      console.error("UpdateUserDetails failed:", err);
    }
  };

  useEffect(() => {
    let condition =
      (user && user.MovementSpeed !== MovementSpeed) ||
      (user && user.DefaultCalibrationMoment !== DefaultCalibrationMoment) ||
      (user && user.PersonalOffset !== PersonalOffset) ||
      (user &&
        user.ReadCalibrationFromBackend !== ReadCalibrationFromBackend) ||
      (user &&
        user.RecommendedSessionsPerWeek !== RecommendedSessionsPerWeek) ||
      (user &&
        user.CalibrationBackend &&
        user.CalibrationBackend.offsetValue !== offsetValue) ||
      (user &&
        user.CalibrationBackend &&
        user.CalibrationBackend.pendlumLength !== pendlumLength) ||
      (user && user.vrOffset !== vrOffset);
    if (condition && otherDetailsEdit) {
      console.log(condition);
      setTempFlag(true);
    }
  }, [
    MovementSpeed,
    DefaultCalibrationMoment,
    PersonalOffset,
    ReadCalibrationFromBackend,
    RecommendedSessionsPerWeek,
    offsetValue,
    pendlumLength,
    vrOffset,
  ]);

  // const restoreToBackValues = () => {
  //   setMovementSpeed()
  //   setDefaultCalibrationMoment()
  //   setPersonalOffset()
  //   setReadCalibrationFromBackend()
  //   setRecommendedSessionsPerWeek()
  //   setOffsetValue()
  //   setPendlumLength()
  //   setVROffset()
  // }

  const UpdateOtherDetails = async () => {
    const washingtonRef = doc(db, "UserData", id);

    // Update PD via backend (saves to both SQL and Firebase)
    await axios.put(`${Cloud_API_URL}/user/${id}/update-pd`, {
      pd: Number(physicalDistance),
    });

    await updateDoc(washingtonRef, {
      MovementSpeed: parseFloat(MovementSpeed),
      DefaultCalibrationMoment: parseFloat(DefaultCalibrationMoment),
      PersonalOffset: parseFloat(PersonalOffset),
      ReadCalibrationFromBackend: ReadCalibrationFromBackend,
      RecommendedSessionsPerWeek: RecommendedSessionsPerWeek,
      CalibrationBackend: {
        offsetValue: parseFloat(offsetValue),
        pendlumLength: parseFloat(pendlumLength),
      },
      VROffset: parseFloat(vrOffset),
      ChangeFlag: tempFlag,
    });

    await updateUserFlag(id, tempFlag);
    await updateHasDoubleVision(id, hasDoubleVisionFlag);
    setOtherDetailsEdit(false);
    getUserData();
  };

  const commentListener = async (commentRef) => {
    commentListenerVar = onSnapshot(commentRef, (snapShot) => {
      if (snapShot.exists()) {
        setComments(snapShot.data().Comments);
        scrollToBottom(comments.length === 0 ? "auto" : "smooth", "scroll");
      }
    });
  };

  const notificationListener = async (notiRef) => {
    notificationListenerVar = onSnapshot(notiRef, (snapShot) => {
      if (snapShot.exists()) {
        // setUserNotificationDoc(snapShot.data());
        setInAppMessages(snapShot.data().notification);
        scrollToBottom(
          inAppMessages.length === 0 ? "auto" : "smooth",
          "scrollAppMessages"
        );
      }
    });
  };

  useEffect(() => {
    return () => {
      if (commentListenerVar) {
        commentListenerVar();
      }
    };
  }, [commentListenerVar]);

  useEffect(() => {
    return () => {
      if (notificationListenerVar) {
        notificationListenerVar();
      }
    };
  }, [notificationListenerVar]);

  const addComment = async (e) => {
    e.preventDefault();
    try {
      if (commentText !== "" && user) {
        if (user.Comments) {
          const docSnap = await getDoc(user.Comments);
          if (docSnap.exists()) {
            await updateDoc(user.Comments, {
              Comments: arrayUnion({
                Text: commentText,
                CreatedOn: new Date(),
              }),
            });
            setCommentText("");
          } else {
            await createCommentDocInDb();
          }
        } else {
          await createCommentDocInDb();
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const scrollToBottom = (property, id) => {
    let scrollDiv = document.getElementById(id);
    // scrollDiv && scrollDiv.lastElementChild.scrollIntoView({ behavior: property });
    scrollDiv &&
      scrollDiv.scroll({
        top: scrollDiv.scrollHeight,
        behavior: property,
      });
    // chatMessagesEndRef.current && chatMessagesEndRef.current.scrollIntoView({ behavior: property });
  };

  const createCommentDocInDb = async () => {
    try {
      const userDocRef = doc(db, "UserData", id);
      const newDocRef = await addDoc(collection(db, "CommentsData"), {
        User: userDocRef,
        Comments: [
          {
            Text: commentText,
            CreatedOn: new Date(),
          },
        ],
      });
      setCommentText("");
      await updateDoc(userDocRef, {
        Comments: newDocRef,
      });
      setUser({ ...user, Comments: newDocRef });
      commentListener(newDocRef);
    } catch (error) {
      console.log(error);
    }
  };
  const getUserAnswerData = async (ids) => {
    let answerIds = ids.map((item) => item.id);

    if (answerIds.length > 0) {
      const answerRef = collection(db, "UserAnswers");

      // Splitting answerIds into chunks of 30
      let chunks = [];
      while (answerIds.length) {
        chunks.push(answerIds.splice(0, 30));
      }

      // Variable to accumulate data from all chunks
      let allAnswersData = [];

      // Fetching answers for each chunk
      for (let chunk of chunks) {
        const answersDocSnap = query(
          answerRef,
          where(documentId(), "in", chunk)
        );
        let answerDocs = await getDocs(answersDocSnap);
        let answersData = answerDocs.docs;

        answersData.sort((a, b) => {
          return (
            new Date(a.data().DateOfAnswering.toDate()) -
            new Date(b.data().DateOfAnswering.toDate())
          );
        });

        allAnswersData = allAnswersData.concat(
          answersData.map((answerDoc) => ({
            id: answerDoc.id,
            ...answerDoc.data(),
          }))
        );
      }

      setAnswerData(allAnswersData);
    }
  };

  const sendInAppMessage = async (e) => {
    e.preventDefault();
    try {
      setInAppAction(true);
      const functionCall = httpsCallable(
        firebaseFunctions,
        "triggerNotification"
      );
      const response = await functionCall({
        uid: id,
        title: "Message from imvi",
        body: inAppMessage,
      });
      setInAppAction(false);
      if (response.data.successCount) {
        let date = new Date();
        date.setDate(date.getDate() + selectedDuration);
        let newData = {
          id: uuidv4(),
          createdOn: new Date(),
          displayTill: date,
          title: {
            en: "Message from imvi",
            sv: "Message from imvi",
          },
          description: {
            en: inAppMessage,
            sv: inAppMessage,
          },
        };
        if (inAppMsgWithFeedback) {
          newData = {
            ...newData,
            buttons: {
              multiSelect: false,
              options: [
                {
                  selected: false,
                  title: { sv: "Ja", en: "Yes" },
                  value: "1",
                },
                {
                  selected: false,
                  title: { sv: "Nej", en: "No" },
                  value: "2",
                },
              ],
            },
          };
        }
        if (user.UserNotifications) {
          const notificationRef = doc(
            db,
            "UserNotifications",
            user.UserNotifications.id
          );
          await updateDoc(notificationRef, {
            notification: [...inAppMessages, newData],
          });
        } else {
          const userDocRef = doc(db, "UserData", id);
          await addDoc(collection(db, "UserNotifications"), {
            User: userDocRef,
            notification: [...inAppMessages, newData],
          });
        }
        scrollToBottom(
          inAppMessages.length === 0 ? "auto" : "smooth",
          "scrollAppMessages"
        );
        setInAppMessage("");
      }
    } catch (error) {
      setInAppAction(false);
      alert("Something went wrong. Please try again");
      console.log(error);
    }
  };

  const displayFeedback = (options) => {
    let message = "Not replied";
    for (let i = 0; i < options.length; i++) {
      if (options[i].selected) {
        message = options[i].title.en;
        break;
      }
    }
    return message;
  };

  const [open, setopen] = useState(false);
  const statusDropdoen = () => {
    setopen(!open);
  };

  const handleCalibrationOnOff = async (event) => {
    try {
      const userRef = doc(db, "UserData", id);
      setCalibrationOn(event.target.checked);

      await updateDoc(userRef, {
        "FeatureFlag.calibration.x": !event.target.checked,
      });

      getUserData();
    } catch (error) {
      console.log(error);
    }
  };

  // const getAnswer = id => {
  //   return answers[id];
  // };

  const getUserReadingSpeedData = async (ids) => {
    let readSpeedIds = [];
    if (ids.length > 0) {
      ids.forEach((item) => {
        readSpeedIds.push(item.id);
      });
    }
    if (readSpeedIds.length > 0) {
      const readingSpeedRef = collection(db, "ReadingSpeed");

      // Splitting ids into chunks of 30
      let chunks = [];
      while (readSpeedIds.length) {
        chunks.push(readSpeedIds.splice(0, 30));
      }

      // Fetching reading speeds for each chunk
      for (let chunk of chunks) {
        const readingSpeedDocSnap = query(
          readingSpeedRef,
          where(documentId(), "in", chunk)
        );
        const readingSpeedDocs = await getDocs(readingSpeedDocSnap);
        let readingSpeedData = readingSpeedDocs.docs;
        readingSpeedData.sort((a, b) => {
          return (
            new Date(a.data().RecordedAtTime.toDate()) -
            new Date(b.data().RecordedAtTime.toDate())
          );
        });
        readingSpeedData.forEach((readingSpeedDoc) => {
          setReadingSpeedData((prevData) => [
            ...prevData,
            {
              id: readingSpeedDoc.id,
              ...readingSpeedDoc.data(),
            },
          ]);
        });
      }
    }
  };

  const checkActiveOrNot = (date) => {
    if (date && checkDateisAfterToday(date.toDate().toDateString())) {
      return "Active";
    } else {
      return "Inactive";
    }
  };

  // const nth = n => {
  //   return ["st", "nd", "rd"][((((n + 90) % 100) - 10) % 10) - 1] || "th";
  // };

  return (
    <Container fluid className="main-content-container px-4 pb-4">
      <div className="bloc-tabs">
        <button
          className={toggleState === 1 ? "tabs active-tabs" : "tabs"}
          onClick={() => toggleTab(1)}
        >
          User Details
        </button>
        <button
          className={toggleState === 2 ? "tabs active-tabs" : "tabs"}
          onClick={() => toggleTab(2)}
        >
          Calibration
        </button>
        <button
          className={toggleState === 3 ? "tabs active-tabs" : "tabs"}
          onClick={() => toggleTab(3)}
        >
          Training Result
        </button>
        {user && user.MonitoringUsers && user.MonitoringUsers.length > 0 && (
          <button
            className={toggleState === 4 ? "tabs active-tabs" : "tabs"}
            onClick={() => toggleTab(4)}
          >
            Monitering Users
          </button>
        )}
        <button
          className={toggleState === 5 ? "tabs active-tabs" : "tabs"}
          onClick={() => toggleTab(5)}
        >
          Statistics
        </button>
      </div>

      <div className="content-tabs">
        <div
          className={toggleState === 1 ? "content  active-content" : "content"}
        >
          {user === "" ? (
            <div className="wrapper">
              <div className="spinner">
                <div className="spinner-1"></div>
                <div className="spinner-2"></div>
                <div className="spinner-3"></div>
              </div>
            </div>
          ) : (
            <div>
              <Row>
                <Col lg="12" md="12" sm="12">
                  <Card small className="mb-4 pt-4">
                    <CardHeader className="border-bottom">
                      <div
                        className="d-flex"
                        style={{
                          justifyContent: "space-between",
                        }}
                      >
                        <div
                          className="d-flex align-items-center"
                          style={{ gap: "30px" }}
                        >
                          <div>
                            <h4 className="mb-0 pl-2">
                              {user.FirstName} {user.LastName}
                              <sup
                                className={
                                  checkActiveOrNot(user.ValidTill) === "Active"
                                    ? "validClass"
                                    : "invalidClass"
                                }
                              >
                                {checkActiveOrNot(user.ValidTill)}
                              </sup>
                            </h4>
                            <span className="text-muted d-block mb-2">
                              {user.Email}
                            </span>
                          </div>
                          {(userRole === "admin" ||
                            userRole === "optician" ||
                            currentUser.email ===
                              "marguerite.tjernberg@ki.se") && (
                            <img
                              src={require("../../../assets/dashboard/flag.png")}
                              onClick={() => setFeatureFlagModal(true)}
                              alt={"Feature Flag"}
                              title={"Feature Flags"}
                              style={{
                                width: "24px",
                                cursor: "pointer",
                              }}
                            />
                          )}
                          {proTraining ? (
                            <img
                              src={require("../../../assets/dashboard/glasses_icon.png")}
                              onClick={() => setShowProTrainingSettings(true)}
                              alt={"Pro Training settings"}
                              title={"Pro Training settings"}
                              style={{
                                width: "24px",
                                cursor: "pointer",
                              }}
                            />
                          ) : null}
                        </div>

                        <div className="d-flex flex-column align-items-end">
                          <div className="d-flex align-items-center">
                            <div>
                              {userDetailsEdit === false ? (
                                <span
                                  className="material-icons"
                                  style={{ cursor: "pointer" }}
                                  onClick={() =>
                                    setUserDetailsEdit(!userDetailsEdit)
                                  }
                                >
                                  edit
                                </span>
                              ) : (
                                <span
                                  className="material-icons"
                                  style={{ cursor: "pointer" }}
                                  onClick={() =>
                                    setUserDetailsEdit(!userDetailsEdit)
                                  }
                                >
                                  close
                                </span>
                              )}
                            </div>
                            <span
                              className="material-icons px-2 text-danger"
                              style={{ cursor: "pointer" }}
                              onClick={() => !deletingUser && deleteUser(id)}
                            >
                              delete
                            </span>
                            <div>
                              <button
                                type="button"
                                className="btn btn-info"
                                style={{ zIndex: 1, marginRight: "5px" }}
                                onClick={() => resetPasswordModal(user.Email)}
                              >
                                Reset Password
                              </button>
                            </div>
                            <TestsCalendar userId={id} />
                            <TrainingProSettings
                              userUUID={id}
                              showModal={showProTrainingSettings}
                              closeCallback={() =>
                                setShowProTrainingSettings(false)
                              }
                            />
                          </div>

                          {/* --- Conditional Reset URL Section --- */}
                          {sqlUserData?.reset_password_url && (
                            <div
                              className="mt-2 d-flex align-items-center"
                              style={{ fontSize: "0.8rem", color: "#6c757d" }}
                            >
                              <span className="mr-1">Reset password URL:</span>
                              <span
                                style={{
                                  maxWidth: "180px",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  display: "inline-block",
                                  marginRight: "8px",
                                  fontStyle: "italic",
                                }}
                                title={sqlUserData.reset_password_url}
                              >
                                {sqlUserData.reset_password_url}
                              </span>
                              <span
                                className="material-icons"
                                style={{
                                  cursor: "pointer",
                                  fontSize: "16px",
                                  color: "#17a2b8",
                                }}
                                onClick={() => {
                                  navigator.clipboard.writeText(
                                    sqlUserData.reset_password_url
                                  );
                                  alert("URL copied!");
                                }}
                                title="Copy Link"
                              >
                                content_copy
                              </span>
                            </div>
                          )}
                        </div>
                      </div>
                    </CardHeader>

                    {!userDetailsEdit ? (
                      <Row>
                        <Col sm="12" md="6" lg="6">
                          <ListGroup flush>
                            <ListGroupItem className="px-4">
                              <div className="progress-wrapper d-flex">
                                <strong className="text-muted d-block mb-2">
                                  Status :{" "}
                                  {userAuthData.disabled === true
                                    ? "InActive"
                                    : "Active"}
                                </strong>
                                <div
                                  style={{
                                    marginLeft: 30,
                                  }}
                                >
                                  <Dropdown
                                    open={open}
                                    size="sm"
                                    className="mr-2"
                                    toggle={() => statusDropdoen()}
                                  >
                                    <DropdownToggle className="dropdown-aa">
                                      <span className="material-icons">
                                        edit
                                      </span>
                                    </DropdownToggle>
                                    <DropdownMenu>
                                      <DropdownItem
                                        onClick={() => UpdateStatus()}
                                      >
                                        {userAuthData.disabled
                                          ? "Enable"
                                          : "Disable"}
                                      </DropdownItem>
                                    </DropdownMenu>
                                  </Dropdown>
                                </div>
                              </div>
                            </ListGroupItem>
                            <ListGroupItem className="px-4">
                              <div className="progress-wrapper">
                                <strong className="text-muted d-block mb-2">
                                  Mobile Number : {user.MobileNumber}
                                </strong>
                              </div>
                            </ListGroupItem>
                            <ListGroupItem className="p-4">
                              <strong className="text-muted d-block mb-2">
                                Age : {user.Age}
                              </strong>
                            </ListGroupItem>
                          </ListGroup>
                        </Col>
                        <Col sm="12" md="6" lg="6">
                          <ListGroup flush>
                            <ListGroupItem className="px-4">
                              <div className="progress-wrapper">
                                <strong className="text-muted d-block mb-2">
                                  Registered At :{" "}
                                  {user.RegisteredOn &&
                                    user.RegisteredOn.toDate().toDateString()}
                                </strong>
                              </div>
                            </ListGroupItem>
                            <ListGroupItem className="px-4">
                              <div className="progress-wrapper">
                                <strong className="text-muted d-block mb-2">
                                  ValidTill :{" "}
                                  {user.ValidTill &&
                                    moment(
                                      user.ValidTill.toDate().toDateString()
                                    ).format("LL")}
                                </strong>
                              </div>
                            </ListGroupItem>
                            <ListGroupItem className="p-4">
                              <strong className="text-muted d-block mb-2">
                                Last Session Done At :{" "}
                                {user.LastSessionDoneAt &&
                                  moment(
                                    user.LastSessionDoneAt.toDate().toString()
                                  ).format("lll")}
                              </strong>
                            </ListGroupItem>
                          </ListGroup>
                        </Col>
                        <Col sm="12" md="6" lg="6">
                          <ListGroup flush>
                            <ListGroupItem className="px-4">
                              <div className="progress-wrapper">
                                <strong className="text-muted d-block mb-2">
                                  User Type :{" "}
                                  {user.UserType ? user.UserType : "-"}
                                </strong>
                              </div>
                            </ListGroupItem>
                            <ListGroupItem className="px-4">
                              <div className="progress-wrapper">
                                <strong className="text-muted d-block mb-2">
                                  Program Subscription Status :{" "}
                                  {user.UserType
                                    ? user.UserType === "Training"
                                      ? "True"
                                      : "False"
                                    : "False"}
                                </strong>
                              </div>
                            </ListGroupItem>
                            <ListGroupItem className="px-4">
                              <div className="progress-wrapper">
                                <strong className="text-muted d-block mb-2">
                                  Has Purchase Subscription :{" "}
                                  {hasSubscription ? "True" : "False"}
                                </strong>
                              </div>
                            </ListGroupItem>
                          </ListGroup>
                        </Col>
                        <Col sm="12" md="6" lg="6">
                          <ListGroup flush>
                            <ListGroupItem className="px-4">
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  checked={calibrationOn}
                                  id="flexSwitchCheckDefault"
                                  onChange={handleCalibrationOnOff}
                                />

                                <strong
                                  className="form-check-label text-muted"
                                  htmlFor="flexSwitchCheckDefault"
                                >
                                  No Calibration
                                </strong>
                              </div>
                            </ListGroupItem>
                            <ListGroupItem className="p-4">
                              <strong className="text-muted d-block mb-2">
                                Application Language :{" "}
                                {deviceData.languageCode
                                  ? deviceData.languageCode
                                  : "-"}
                              </strong>
                            </ListGroupItem>
                            <ListGroupItem className="p-4">
                              <strong className="text-muted d-block mb-2">
                                Reading Test Language :{" "}
                                {user.ReadingTestLanguage
                                  ? user.ReadingTestLanguage
                                  : "-"}
                              </strong>
                            </ListGroupItem>
                          </ListGroup>
                        </Col>
                      </Row>
                    ) : (
                      <Row>
                        <Col>
                          <ListGroup flush>
                            <ListGroupItem className="px-4">
                              <Form>
                                <FormGroup>
                                  <label htmlFor="#MobileNumber">
                                    Mobile Number
                                  </label>
                                  <FormInput
                                    id="#MobileNumber"
                                    placeholder="Mobile Number"
                                    type="number"
                                    value={MobileNumber}
                                    onChange={(e) =>
                                      setMobileNumber(e.target.value)
                                    }
                                  />
                                </FormGroup>
                                <FormGroup>
                                  <label htmlFor="#Age">Age</label>
                                  <FormInput
                                    id="#Age"
                                    placeholder="Age"
                                    type="number"
                                    value={Age}
                                    onWheel={(event) => {
                                      event.currentTarget.blur();
                                      event.preventDefault();
                                    }}
                                    onChange={(e) => setAge(e.target.value)}
                                  />
                                </FormGroup>
                                <div className="form-group">
                                  <label>Valid Till</label>
                                  <br />
                                  <ThemeProvider theme={theme}>
                                    <LocalizationProvider
                                      dateAdapter={AdapterDayjs}
                                    >
                                      <DatePicker
                                        value={dayjs(ValidTill)}
                                        onChange={(date) => setValidTill(date)}
                                        renderInput={(params) => (
                                          <TextField {...params} fullWidth />
                                        )}
                                        slotProps={{
                                          textField: {
                                            fullWidth: true,
                                          },
                                        }}
                                        orientation="portrait"
                                      />
                                    </LocalizationProvider>
                                  </ThemeProvider>
                                </div>
                                <div className="d-flex w-70">
                                  <Button
                                    theme="secondary"
                                    className="submit_button"
                                    onClick={() =>
                                      setUserDetailsEdit(!userDetailsEdit)
                                    }
                                  >
                                    Close
                                  </Button>
                                  <Button
                                    theme="success"
                                    className="submit_button"
                                    onClick={() => UpdateUserDetails()}
                                  >
                                    Submit
                                  </Button>
                                </div>
                              </Form>
                            </ListGroupItem>
                          </ListGroup>
                        </Col>
                      </Row>
                    )}
                  </Card>
                </Col>
              </Row>
              <Row>
                <Col md="6" sm="12">
                  <Card small className="mb-4 pt-4">
                    <CardHeader className="border-bottom">
                      <h4 className="mb-0">Guardian Details</h4>
                    </CardHeader>
                    <ListGroup flush>
                      <ListGroupItem className="px-4">
                        <div className="progress-wrapper">
                          <strong className="text-muted d-block mb-1">
                            Approved by :{" "}
                            {approvedBy &&
                            approvedBy.first_name &&
                            approvedBy.last_name
                              ? `${approvedBy.first_name} ${approvedBy.last_name} (${approvedBy.email})`
                              : "-"}
                          </strong>
                        </div>
                      </ListGroupItem>
                      <ListGroupItem className="px-4">
                        <div className="progress-wrapper">
                          <strong className="text-muted d-block mb-1">
                            Name :{" "}
                            {guardian
                              ? guardian.Name
                                ? guardian.Name
                                : "-"
                              : "-"}
                          </strong>
                        </div>
                      </ListGroupItem>
                      <ListGroupItem className="px-4">
                        <div className="progress-wrapper">
                          <strong className="text-muted d-block mb-1">
                            Email :{" "}
                            {guardian
                              ? guardian.Email
                                ? guardian.Email
                                : "-"
                              : "-"}
                          </strong>
                        </div>
                      </ListGroupItem>
                      <ListGroupItem className="p-4">
                        <strong className="text-muted d-block mb-1">
                          Mobile Number :{" "}
                          {guardian
                            ? guardian.MobileNumber
                              ? guardian.MobileNumber
                              : "-"
                            : "-"}
                        </strong>
                      </ListGroupItem>
                      <ListGroupItem className="p-4 d-flex justify-content-between">
                        <strong className="text-muted d-block mb-1">
                          Approval Status :{" "}
                          {approvalStatusLoading
                            ? "Loading"
                            : approved
                            ? "True"
                            : "False"}
                        </strong>
                        {!approvalStatusLoading &&
                          !approved &&
                          user &&
                          user.Age <= 17 && (
                            <button
                              type="button"
                              className="btn btn-info"
                              onClick={() => sendApprovalRequest(user.Email)}
                            >
                              Send Request
                            </button>
                          )}
                      </ListGroupItem>
                    </ListGroup>
                  </Card>
                  <Card>
                    <CardHeader className="border-bottom">
                      <h4 className="mb-0">Comment Section</h4>
                    </CardHeader>
                    <div className="chat_wrapper">
                      <div className="chat_content_wrapper">
                        <div className="chat_messages" id="scroll">
                          {comments.map((message, index) => {
                            return (
                              <div className="chat_message_wrapper" key={index}>
                                <p className="chat_message_text">
                                  {message.Text}
                                </p>
                                <p className="chat_message_time">
                                  {moment(
                                    message.CreatedOn.toDate().toString()
                                  ).format("Y-MM-DD LT")}
                                </p>
                              </div>
                            );
                          })}
                          <div id="scrollElement" ref={chatMessagesEndRef} />
                        </div>
                        <div className="chat_input_wrapper">
                          <form onSubmit={addComment}>
                            <input
                              type="text"
                              className="chat_input"
                              value={commentText}
                              onChange={(e) => setCommentText(e.target.value)}
                            />
                          </form>
                        </div>
                      </div>
                    </div>
                  </Card>
                </Col>
                <Col md="6" sm="12">
                  <Card small className="mb-4 pt-4">
                    <CardHeader className="border-bottom">
                      <div
                        className="d-flex"
                        style={{
                          justifyContent: "space-between",
                        }}
                      >
                        <h4 className="mb-0">Other Details</h4>
                        <h6>
                          <span
                            className="material-icons"
                            style={{
                              cursor: "pointer",
                            }}
                            onClick={() =>
                              setOtherDetailsEdit(!otherDetailsEdit)
                            }
                          >
                            edit
                          </span>
                        </h6>
                      </div>
                    </CardHeader>
                    {!otherDetailsEdit ? (
                      <ListGroup flush>
                        <ListGroupItem className="px-4">
                          <div className="progress-wrapper">
                            <strong className="text-muted d-block">
                              Movement Speed : {user.MovementSpeed}
                            </strong>
                          </div>
                        </ListGroupItem>
                        <ListGroupItem className="px-4">
                          <div className="progress-wrapper">
                            <strong className="text-muted d-block">
                              Calibration Moment Speed :{" "}
                              {user.DefaultCalibrationMoment
                                ? user.DefaultCalibrationMoment
                                : "-"}
                            </strong>
                          </div>
                        </ListGroupItem>
                        <ListGroupItem className="p-4">
                          <div className="progress-wrapper">
                            <strong className="text-muted d-block">
                              Personal Offset : {user.PersonalOffset}
                            </strong>
                          </div>
                        </ListGroupItem>
                        <ListGroupItem className="p-4">
                          <div className="progress-wrapper">
                            <strong className="text-muted d-block">
                              Pupil Distance : {user.PhysicalDistance}
                            </strong>
                          </div>
                        </ListGroupItem>
                        <ListGroupItem className="p-4">
                          <strong className="text-muted d-block">
                            Read Calibration From Backend :{" "}
                            {user.ReadCalibrationFromBackend ? "Yes" : "No"}
                          </strong>
                        </ListGroupItem>
                        <ListGroupItem className="p-4">
                          <strong className="text-muted d-block">
                            Offset Value :{" "}
                            {user.CalibrationBackend
                              ? user.CalibrationBackend.offsetValue
                              : "-"}
                          </strong>
                        </ListGroupItem>
                        <ListGroupItem className="p-4">
                          <strong className="text-muted d-block">
                            Pendlum Length :{" "}
                            {user.CalibrationBackend
                              ? user.CalibrationBackend.pendlumLength
                              : "-"}
                          </strong>
                        </ListGroupItem>
                        <ListGroupItem className="p-4">
                          <strong className="text-muted d-block">
                            Recommended Sessions Per Week :{" "}
                            {user.RecommendedSessionsPerWeek}
                          </strong>
                        </ListGroupItem>
                        <ListGroupItem className="p-4">
                          <strong className="text-muted d-block">
                            VR Offset : {user.VROffset ? user.VROffset : "-"}
                          </strong>
                        </ListGroupItem>
                        <ListGroupItem className="p-4">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              readOnly
                              checked={tempFlag}
                              id="flagTemp"
                            />
                            <strong
                              className="form-check-label text-muted"
                              htmlFor="flagTemp"
                            >
                              Flag
                            </strong>
                          </div>
                        </ListGroupItem>
                        <ListGroupItem className="p-4">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              readOnly
                              checked={hasDoubleVisionFlag}
                              id="hasDoubleVisionTemp"
                            />
                            <strong
                              className="form-check-label text-muted"
                              htmlFor="hasDoubleVisionTemp"
                            >
                              Has double vision
                            </strong>
                          </div>
                        </ListGroupItem>
                      </ListGroup>
                    ) : (
                      <ListGroup flush>
                        <ListGroupItem className="px-4">
                          <Form>
                            <FormGroup>
                              <label htmlFor="#MovementSpeed">
                                Movement Speed
                              </label>
                              <FormInput
                                id="#MovementSpeed"
                                placeholder="Movement Speed"
                                type="number"
                                onWheel={(event) => {
                                  event.currentTarget.blur();
                                  event.preventDefault();
                                }}
                                value={MovementSpeed}
                                onChange={(e) =>
                                  setMovementSpeed(e.target.value)
                                }
                              />
                            </FormGroup>
                            <FormGroup>
                              <label htmlFor="#DefaultCalibrationMoment">
                                Calibration Moment Speed
                              </label>
                              <FormInput
                                id="#DefaultCalibrationMoment"
                                placeholder="Calibration Moment Speed"
                                type="number"
                                onWheel={(event) => {
                                  event.currentTarget.blur();
                                  event.preventDefault();
                                }}
                                value={DefaultCalibrationMoment}
                                onChange={(e) =>
                                  setDefaultCalibrationMoment(e.target.value)
                                }
                              />
                            </FormGroup>
                            <FormGroup>
                              <label htmlFor="#PersonalOffset">
                                Personal Offset
                              </label>
                              <FormInput
                                id="#PersonalOffset"
                                placeholder="Personal Offset"
                                type="number"
                                value={PersonalOffset}
                                onWheel={(event) => {
                                  event.currentTarget.blur();
                                  event.preventDefault();
                                }}
                                onChange={(e) =>
                                  setPersonalOffset(e.target.value)
                                }
                              />
                            </FormGroup>
                            <FormGroup>
                              <label htmlFor="#PersonalOffset">
                                Pupil Distance
                              </label>
                              <FormInput
                                id="#PhysicalDistance"
                                placeholder="Pupil Distance"
                                type="number"
                                value={physicalDistance}
                                onWheel={(event) => {
                                  event.currentTarget.blur();
                                  event.preventDefault();
                                }}
                                onChange={(e) =>
                                  setPhysicalDistance(e.target.value)
                                }
                              />
                            </FormGroup>
                            <FormGroup>
                              <label htmlFor="#ReadCalibrationFromBackend">
                                Read Calibration From Backend
                              </label>
                              <FormSelect
                                value={ReadCalibrationFromBackend}
                                onChange={(e) => {
                                  if (e.target.value === "true") {
                                    setReadCalibrationFromBackend(true);
                                  } else {
                                    setReadCalibrationFromBackend(false);
                                  }
                                }}
                              >
                                <option value="true">Yes</option>
                                <option value="false">No</option>
                              </FormSelect>
                            </FormGroup>
                            <FormGroup>
                              <label htmlFor="#OffSetValue">Offset Value</label>
                              <FormInput
                                id="#OffSetValue"
                                value={offsetValue}
                                type="number"
                                onWheel={(event) => {
                                  event.currentTarget.blur();
                                  event.preventDefault();
                                }}
                                placeholder="Offset Value"
                                onChange={(e) => setOffsetValue(e.target.value)}
                              />
                            </FormGroup>
                            <FormGroup>
                              <label htmlFor="#PendlumLength">
                                Pendlum Length
                              </label>
                              <FormInput
                                id="#PendlumLength"
                                value={pendlumLength}
                                type="number"
                                onWheel={(event) => {
                                  event.currentTarget.blur();
                                  event.preventDefault();
                                }}
                                placeholder="Pendlum Length"
                                onChange={(e) =>
                                  setPendlumLength(e.target.value)
                                }
                              />
                            </FormGroup>
                            <FormGroup>
                              <label htmlFor="#RecommendedSessionsPerWeek">
                                Recommended Sessions Per Week
                              </label>
                              <FormInput
                                id="#RecommendedSessionsPerWeek"
                                value={RecommendedSessionsPerWeek}
                                type="number"
                                onWheel={(event) => {
                                  event.currentTarget.blur();
                                  event.preventDefault();
                                }}
                                placeholder="Recommended Sessions Per Week"
                                onChange={(e) =>
                                  setRecommendedSessionsPerWeek(e.target.value)
                                }
                              />
                            </FormGroup>
                            <FormGroup>
                              <label htmlFor="#VROffset">VR Offset</label>
                              <FormInput
                                id="#VROffset"
                                value={vrOffset}
                                type="number"
                                onWheel={(event) => {
                                  event.currentTarget.blur();
                                  event.preventDefault();
                                }}
                                placeholder="VR Offset"
                                onChange={(e) => setVROffset(e.target.value)}
                              />
                            </FormGroup>
                            <FormGroup>
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  checked={tempFlag}
                                  id="flagTempEdit"
                                  onChange={(e) => setTempFlag(!tempFlag)}
                                />
                                <strong
                                  className="form-check-label text-muted"
                                  htmlFor="flagTempEdit"
                                >
                                  Flag
                                </strong>
                              </div>
                            </FormGroup>
                            <FormGroup>
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  id="hasDoubleVisionTemp"
                                  checked={hasDoubleVisionFlag}
                                  onChange={(e) =>
                                    setHasDoubleVisionFlag(e.target.checked)
                                  }
                                />
                                <strong
                                  className="form-check-label text-muted"
                                  htmlFor="hasDoubleVisionTemp"
                                >
                                  Has double vision
                                </strong>
                              </div>
                            </FormGroup>
                            <div className="d-flex">
                              <Button
                                theme="secondary"
                                className="submit_button"
                                onClick={() => {
                                  setHasDoubleVisionFlag(
                                    sqlUserData.has_double_vision
                                  );
                                  setTempFlag(changeFlag);
                                  setOtherDetailsEdit(!otherDetailsEdit);
                                }}
                              >
                                Close
                              </Button>
                              <Button
                                theme="success"
                                className="submit_button"
                                onClick={() => UpdateOtherDetails()}
                              >
                                Submit
                              </Button>
                            </div>
                          </Form>
                        </ListGroupItem>
                      </ListGroup>
                    )}
                  </Card>
                </Col>
              </Row>
              <Row>
                <Col md="6">
                  <Card small className="mb-4">
                    <CardHeader className="border-bottom">
                      Vergence Test
                    </CardHeader>
                    <CardBody>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          height: 350,
                          width: "100%",
                          "& .actions": {
                            color: "text.secondary",
                          },
                          "& .textPrimary": {
                            color: "text.primary",
                          },
                        }}
                      >
                        <VergenceTestsGrid data={combinedData} />
                      </Box>
                    </CardBody>
                  </Card>
                </Col>
                <Col md="6">
                  <Card small className="mb-4">
                    <CardHeader className="border-bottom">
                      Reading Speed Score
                    </CardHeader>
                    <CardBody>
                      <FullFeaturedCrudGrid
                        data={readingSpeedData}
                        userId={id}
                      />
                    </CardBody>
                  </Card>
                </Col>
              </Row>
              {/* Reading tests results */}
              <Row>
                <Col md="6">
                  <Card small className="mb-4">
                    <CardHeader className="border-bottom">
                      Proprietary Reading Speed Score
                    </CardHeader>
                    <CardBody>
                      <ProprietaryTestsGrid
                        data={readingTestsScores}
                        email={user.Email}
                      />
                    </CardBody>
                  </Card>
                </Col>

                <Col md="6">
                  <Card small className="mb-4">
                    <CardHeader className="border-bottom">
                      Mobile Details
                    </CardHeader>
                    <CardBody>
                      <p>
                        Resolution :{" "}
                        {user.CalibrationBackend
                          ? user.CalibrationBackend.deviceDimensions
                            ? user.CalibrationBackend.deviceDimensions.width
                              ? user.CalibrationBackend.deviceDimensions.width *
                                  user.CalibrationBackend.deviceDimensions
                                    .pixelRatio +
                                " x " +
                                user.CalibrationBackend.deviceDimensions
                                  .height *
                                  user.CalibrationBackend.deviceDimensions
                                    .pixelRatio
                              : "-"
                            : "-"
                          : "-"}
                      </p>
                      <p>
                        Mobile:{" "}
                        {deviceData.manufacturer + " " + deviceData.model}
                      </p>
                      <p>OS : {deviceData.os && deviceData.os}</p>
                      <p>
                        OS Version:{" "}
                        {deviceData.osversion && deviceData.osversion}
                      </p>
                      <p>
                        App Version : {deviceData.version && deviceData.version}
                      </p>
                    </CardBody>
                  </Card>
                  <Card small className="mb-4">
                    <CardHeader className="border-bottom">
                      Register Question
                    </CardHeader>
                    <CardBody>
                      <Table responsive>
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Question</th>
                            <th>Answer</th>
                          </tr>
                        </thead>
                        <tbody>
                          {groupedAnswers.map((item, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>{item.question}</td>
                              <td>{item.answers}</td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </CardBody>
                  </Card>
                </Col>
              </Row>

              <Row>
                {/* Left Column: In-App Messages */}
                <Col md="6">
                  <Card small className="mb-4">
                    <CardHeader className="border-bottom">
                      In-App Messages
                    </CardHeader>
                    <CardBody>
                      <div className="chat_wrapper">
                        <div className="chat_content_wrapper">
                          <div className="chat_messages" id="scrollAppMessages">
                            {inAppMessages.map((message, index) => {
                              return (
                                <div
                                  className="chat_message_wrapper"
                                  key={index}
                                >
                                  <p className="chat_message_text">
                                    {message.description.en}
                                    {message.buttons && (
                                      <>
                                        <br />
                                        <span
                                          style={{
                                            color: "brown",
                                            fontSize: "12px",
                                          }}
                                        >
                                          Feedback-
                                          {displayFeedback(
                                            message.buttons.options
                                          )}
                                        </span>
                                      </>
                                    )}
                                  </p>
                                  <p className="chat_message_time">
                                    {moment(
                                      message.createdOn.toDate().toString()
                                    ).format("Y-MM-DD LT")}
                                  </p>
                                </div>
                              );
                            })}
                            <div
                              id="inAppScrollElement"
                              ref={inAppMessagesEndRef}
                            />
                          </div>
                          <div className="chat_input_wrapper">
                            <form onSubmit={sendInAppMessage}>
                              <div className="d-flex align-items-center gap-2">
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    checked={inAppMsgWithFeedback}
                                    id="msgFeedback"
                                    onChange={() =>
                                      setInAppMsgWithFeedback(
                                        !inAppMsgWithFeedback
                                      )
                                    }
                                  />
                                  <strong
                                    className="form-check-label text-muted"
                                    htmlFor="msgFeedback"
                                  >
                                    with Yes/No Feedback
                                  </strong>
                                </div>
                                <div
                                  className="dropdown-container"
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <select
                                    className="form-select smaller-select"
                                    value={selectedDuration}
                                    onChange={(e) =>
                                      setSelectedDuration(
                                        parseInt(e.target.value, 10)
                                      )
                                    }
                                  >
                                    <option value="7">7 days</option>
                                    <option value="30">30 days</option>
                                    <option value="90">90 days</option>
                                  </select>
                                </div>
                                <div
                                  className="tooltip-container"
                                  style={{
                                    marginBottom: "10px",
                                  }}
                                >
                                  <Tooltip title="The Availability of the messages">
                                    <InfoIcon />
                                  </Tooltip>
                                </div>
                              </div>
                              <div className="d-flex gap-2">
                                <input
                                  type="text"
                                  className="chat_input"
                                  value={inAppMessage}
                                  onChange={(e) =>
                                    setInAppMessage(e.target.value)
                                  }
                                />
                                <button
                                  type="submit"
                                  disabled={inAppAction}
                                  className="btn btn-info"
                                >
                                  {inAppAction ? "Sending" : "Send"}
                                </button>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </Col>

                {/* Right Column: Post Training Questions */}
                <Col md="6">
                  <Card small className="mb-4">
                    <CardHeader className="border-bottom">
                      Post Training Questions
                    </CardHeader>
                    <CardBody>
                      <Table responsive>
                        <thead>
                          <tr>
                            <th>#</th>
                            {/* <th>Question ID</th> */}
                            <th>Question</th>
                            {/* <th>Answer ID</th> */}
                            <th>Answer</th>
                            <th>Created At</th>
                          </tr>
                        </thead>
                        <tbody>
                          {trainingQuestions.map((item, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              {/* <td>{item.question_id}</td> */}
                              <td>{item.question}</td>
                              {/* <td>{item.answer_id}</td> */}
                              <td>{item.answer}</td>
                              <td>
                                {new Date(item.created_at).toLocaleString()}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </div>
          )}
        </div>
        <div
          className={toggleState === 2 ? "content  active-content" : "content"}
        >
          <Row>
            <Col>
              {" "}
              {user && toggleState === 2 && <Calibration userdata={user} />}
            </Col>
          </Row>
        </div>

        <div
          className={toggleState === 3 ? "content active-content" : "content"}
        >
          <Row>
            <Col>
              {" "}
              {user && toggleState === 3 && <TrainingResult userdata={user} />}
            </Col>
          </Row>
        </div>

        <div
          className={toggleState === 4 ? "content active-content" : "content"}
        >
          <Row>
            <Col>
              {user && toggleState === 4 && <MonitoringUsers user={user} />}
            </Col>
          </Row>
        </div>

        <div
          className={toggleState === 5 ? "content active-content" : "content"}
        >
          <Row>
            <Col>
              {user && toggleState === 5 && (
                <Answers
                  isAuth={true}
                  userData={user}
                  readingTestsScores={readingTestsScores}
                  id={id}
                />
              )}
            </Col>
          </Row>
        </div>
      </div>
      {featureFlagModal ? (
        <FeatureFlagModal
          isOpen={featureFlagModal}
          email={user.Email}
          uuid={id}
          onRequestClose={() => {
            setFeatureFlagModal(false);
            getUserData();
          }}
        />
      ) : null}
      <Modal open={modalVisible} toggle={resetPasswordModal}>
        <ModalHeader>Reset Password</ModalHeader>
        <ModalBody>
          <p className="text-center">Confirm Reset Password</p>
          <div
            style={{
              display: "flex",
              justifyContent: "space-evenly",
            }}
          >
            <button
              type="button"
              className="btn btn-success"
              onClick={() => sendResetPasswordLink(resetEmail)}
            >
              Confirm
            </button>
            <button
              type="button"
              className="btn btn-warning"
              onClick={() => resetPasswordModal("")}
            >
              Cancel
            </button>
          </div>
          {resetLoading && resetResponse !== "" && (
            <p className="text-center mt-2">{resetResponse}</p>
          )}
        </ModalBody>
      </Modal>
    </Container>
  );
};

export default Userdetails;
